export const useEmptyMessageVisibilitySync = controller => {
  Object.assign(controller, {
    sync (listRepresentationTarget, emptyMessageTarget) {
      const hasItems = listRepresentationTarget.querySelectorAll('.link').length > 0
      emptyMessageTarget.style.display = hasItems ? 'none' : 'block'
    }
  })
}
